import React, { useEffect, useRef } from "react";
import { IPetsyTrackerProps } from "./PetsyTracker.types";
import { pushDataToGTM } from "../../KnoseAPI/Lib/Utils";
import {
  getGTMQuoteData,
  getGTMQuoteDataEventName,
} from "../../util/helper-functions";
import "./PetsyTracker.scss";
import {
  getFlowDataDirect,
  setFlowDataDirect,
  useFlowData,
} from "@adaptis/flow-components";

export default function PetsyTracker(props: IPetsyTrackerProps) {
  function useOnUnmount(callback: () => void) {
    const onUnmount = useRef<(() => void) | null>(null);
    onUnmount.current = callback;

    useEffect(() => {
      return () => onUnmount.current?.();
    }, []);
  }

  useOnUnmount(() => {
    setFlowDataDirect("prev-slug", props.stepSlug);
  });

  const { getData } = useFlowData();

  React.useEffect(() => {
    let prevSlug = getFlowDataDirect("prev-slug");
    const petId = getData("id");

    if (prevSlug != undefined) {
      pushDataToGTM(
        getGTMQuoteDataEventName(prevSlug),
        getGTMQuoteData(prevSlug, undefined, petId)
      );
    }
  }, []);

  return <></>;
}
